import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
import { onMounted, ref, computed } from 'vue';
import OnboardService from '@/services/OnboardService';
import PlanSelection from './PlanSelection.vue';
import { usePlanSelection } from '@/composables/usePlanSelection';
export default {
  __name: 'TrialSummaryMessage',
  props: {
    userService: Object,
    leanLawApi: Object
  },
  setup(__props) {
    const props = __props;
    const msg = ref({
      summary: '',
      level: '',
      isClickable: false,
      href: '',
      sref: ''
    });
    const loading = ref(true);
    const localShowPlans = ref(false);

    // Use the composable for global plan selection state
    const {
      showPlanSelectionModal,
      closePlanSelection
    } = usePlanSelection();

    // Combine local and global plan selection state
    const showPlans = computed(() => {
      const result = localShowPlans.value || showPlanSelectionModal.value;
      return result;
    });
    function go() {
      if (msg.value.href) {
        return window.open(msg.value.href);
      }
      if (msg.value.sref) {
        localShowPlans.value = true;
        return true;
      }
    }
    function closePlans() {
      // Close both local and global plan selection states
      localShowPlans.value = false;
      closePlanSelection();
    }
    onMounted(() => {
      new OnboardService(props.userService, props.leanLawApi).message().then(message => {
        msg.value = message;
      }).finally(() => {
        loading.value = false;
      });
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [!loading.value && msg.value && msg.value.summary ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["relative inline-flex max-w-sm justify-center px-2 pr-8 text-sm font-medium rounded-l-lg z-10", {
          'bg-error': msg.value && (msg.value.level === 'error' || msg.value.level === 'warning'),
          'bg-success': msg.value && msg.value.level === 'info'
        }])
      }, [_createElementVNode("span", {
        class: _normalizeClass({
          'cursor-pointer hover:underline hover:opacity-80': msg.value && msg.value.isClickable
        }),
        onClick: _cache[0] || (_cache[0] = $event => msg.value && msg.value.isClickable ? go() : null)
      }, _toDisplayString(msg.value.summary), 3), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "absolute right-0 top-0 h-full w-0 border-r-[26px] border-t-[10px] border-b-[10px] border-r-white border-t-transparent border-b-transparent"
      }, null, -1))], 2)) : _createCommentVNode("", true), showPlans.value ? (_openBlock(), _createBlock(PlanSelection, {
        key: 1,
        onCancel: closePlans
      })) : _createCommentVNode("", true)]);
    };
  }
};